import { motion } from "framer-motion";
import { RevealMask } from "@/components/motion/Reveal";
import ScrambleText from "@/components/motion/ScrambleText";
import ParallaxImage from "@/components/motion/ParallaxImage";
import { founders } from "@/data/content";

export default function FoundersSection() {
  return (
    <section data-testid="founders" className="border-t border-line bg-ink text-bone">
      <div className="mx-auto max-w-[1600px] px-5 py-20 sm:py-24 md:py-28 lg:py-36 xl:py-40 sm:px-8 md:px-10 lg:px-12 xl:px-16">
        <div className="mb-10 sm:mb-12 md:mb-16">
          <ScrambleText as="p" text="Founders" className="mb-4 block text-xs font-bold uppercase tracking-[0.22em] text-accent" />
          <RevealMask as="h2" className="font-display text-5xl font-extrabold leading-[0.95] tracking-tight md:text-7xl">
            Founder-led,
          </RevealMask>
          <RevealMask as="h2" delay={0.08} className="font-serif text-5xl font-normal italic leading-[0.95] text-bone/70 md:text-7xl">
            hands-on.
          </RevealMask>
        </div>

        <div className="grid gap-10 md:grid-cols-2 md:gap-12 lg:gap-16">
          {founders.map((f, i) => (
            <motion.div
              key={f.slug}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10%" }}
              transition={{ duration: 0.8, delay: i * 0.1, ease: [0.76, 0, 0.24, 1] }}
            >
              <div className="group relative aspect-[3/4] overflow-hidden bg-bone/10">
                <ParallaxImage
                  src={f.image}
                  alt={f.name}
                  className="absolute inset-0"
                  strength={6}
                  imgClassName="grayscale transition-all duration-700 group-hover:grayscale-0"
                />
              </div>
              <h3 className="mt-6 font-display text-3xl font-extrabold md:text-4xl">{f.name}</h3>
              <p className="mt-1 text-sm font-bold uppercase tracking-[0.14em] text-accent">{f.role}</p>
              <div className="mt-5 max-w-xl space-y-4 text-base leading-relaxed text-bone/75">
                <p>{f.bio}</p>
                {f.quote ? (
                  <p className="border-l-2 border-accent pl-4 font-serif text-lg italic text-bone/90">
                    "{f.quote}"
                  </p>
                ) : null}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
